module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-passport"
  }, [_c('passport-icons'), _vm._v(" "), _c('div', {
    staticClass: "p-passport__topbar"
  }, [_c('div', {
    staticClass: "p-passport__loggedout",
    style: (!_vm.getUserId ? 'display: flex' : 'display: none')
  }, [_c('div', {
    staticClass: "p-passport__topbar-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-passport__topbar-right"
  }, [_c('span', {
    staticClass: "p-passport__topbar--text"
  }, [_vm._v(_vm._s(_vm.passportText))]), _vm._v(" "), (!_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [(_vm.isPassportOpen) ? _c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#passport"
    }
  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__loggedin",
    style: (_vm.getUserId ? 'display: flex' : 'display: none')
  }, [_c('div', {
    staticClass: "p-passport__topbar-left"
  }, [_c('span', {
    staticClass: "p-passport__profile-name"
  }, [_vm._v("\n                    " + _vm._s(_vm.getUserFullName) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__topbar-right"
  }, [_c('div', {
    staticClass: "p-passport__topbar-right-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "https://asbestos.bc-legal.co.uk/?authenticate=" + this.getToken,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app-asbestos",
    attrs: {
      "id": "asbestos",
      "viewBox": "0 0 147.8 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#asbestos"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('a', {
    attrs: {
      "href": 'https://abcnoise.bc-legal.co.uk/?authenticate=' + this.getToken,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app-noise",
    attrs: {
      "id": "noise",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#noise"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app-quantum",
    attrs: {
      "id": "quantum",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#quantum"
    }
  })])])]), _vm._v(" "), (!_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isPassportOpen) ? _c('div', {
    staticClass: "p-passport__icon-wrapper"
  }, [_c('svg', {
    staticClass: "p-passport__icon p-passport__icon--space p-passport__icon--app p-passport__icon--close",
    attrs: {
      "id": "passport",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#passport"
    }
  })])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "p-passport__content",
    style: (this.initialLoad || _vm.checkAuthStatus() ? 'display: flex' : '')
  }, [(_vm.checkAuthStatus()) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('svg', {
    staticClass: "p-passport__icon--passport u-margin-top--small u-margin-bottom--small",
    attrs: {
      "height": "70",
      "width": "200",
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 305.8 108.7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.2 97.4c0 .6-.3 1.2-.8 1.6-.5.4-1.1.7-1.7.7-.4 0-.8-.1-1.2-.4s-.7-.6-.9-1.1l-3.3-7.5H8l-3.3 7.5c-.2.5-.5.8-.9 1.1-.4.3-.8.4-1.3.4-.7 0-1.3-.2-1.8-.7-.5-.4-.8-1-.8-1.6 0-.3.1-.6.3-1l14.1-30.8c.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.6-.5s1.1.1 1.6.5c.5.3.9.7 1.1 1.3L34 96.4c.1.4.2.8.2 1zM9.8 86.6h14.7l-7.3-16.5-7.4 16.5zM65 84.3c1.1 1.5 1.7 3.3 1.7 5.5 0 3-1 5.4-3.1 7.1-2.1 1.7-5 2.5-8.7 2.5H42.1c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12.2c3.6 0 6.5.8 8.5 2.4 2 1.6 3.1 3.9 3.1 6.8 0 1.9-.5 3.5-1.5 4.8-1 1.4-2.4 2.4-4.1 3 2 .7 3.6 1.7 4.7 3.1zm-20.4-4.9h8.9c4.9 0 7.4-1.9 7.4-5.6 0-1.9-.6-3.3-1.8-4.2s-3.1-1.3-5.6-1.3h-8.9v11.1zm15.3 14.5c1.2-.9 1.8-2.4 1.8-4.4 0-2-.6-3.5-1.8-4.5-1.2-1-3.1-1.5-5.6-1.5h-9.7v11.7h9.7c2.6.1 4.4-.4 5.6-1.3zM80 97.7c-2.5-1.4-4.4-3.5-5.8-6.3-1.3-2.7-2-5.9-2-9.6 0-3.7.7-6.9 2-9.6 1.3-2.7 3.3-4.8 5.8-6.3s5.4-2.2 8.8-2.2c2.2 0 4.3.3 6.3 1s3.7 1.7 5.1 3c.6.5 1 1.2 1 2 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.2.6-.6 0-1.1-.2-1.6-.7-1.6-1.2-3.1-2-4.4-2.5-1.3-.5-2.8-.7-4.5-.7-3.7 0-6.5 1.2-8.4 3.6-2 2.4-3 5.8-3 10.2 0 4.5 1 7.9 3 10.3 2 2.4 4.8 3.6 8.4 3.6 1.6 0 3.1-.3 4.4-.8s2.8-1.3 4.5-2.5c.7-.4 1.2-.7 1.6-.7.5 0 .9.2 1.2.6.3.4.5.9.5 1.5 0 .8-.3 1.5-1 2-1.5 1.3-3.2 2.3-5.1 3-2 .7-4 1-6.3 1-3.4.1-6.3-.6-8.8-2zM108 99c-.5-.5-.7-1.1-.7-1.9V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12c3.7 0 6.6.9 8.7 2.8 2.1 1.8 3.1 4.4 3.1 7.8 0 3.3-1 5.9-3.1 7.8-2.1 1.9-5 2.8-8.7 2.8h-9.5v11.8c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7-.1-1.3-.3-1.8-.8zm13.3-17.8c4.9 0 7.4-2.2 7.4-6.5s-2.5-6.4-7.4-6.4h-8.9v12.8h8.9zM156.2 76.9c1.6 1.6 2.4 4.1 2.4 7.5v12.9c0 .8-.2 1.4-.6 1.8-.4.4-1 .6-1.8.6-.7 0-1.3-.2-1.8-.7-.4-.4-.7-1-.7-1.8v-1.8c-.6 1.4-1.6 2.5-2.8 3.2s-2.7 1.1-4.4 1.1c-1.6 0-3.1-.3-4.4-1-1.3-.7-2.4-1.6-3.1-2.7s-1.1-2.5-1.1-3.9c0-1.8.5-3.2 1.4-4.2.9-1 2.4-1.7 4.5-2.2 2.1-.4 5-.7 8.7-.7h1.2v-1.5c0-1.9-.4-3.2-1.2-4-.8-.8-2-1.3-3.7-1.3-1.2 0-2.3.2-3.3.5s-2.2.7-3.4 1.3c-.9.5-1.5.8-1.9.8-.5 0-.9-.2-1.2-.5-.3-.4-.5-.8-.5-1.4 0-.5.1-.9.4-1.3.3-.4.7-.8 1.4-1.1 1.2-.6 2.5-1.1 4.1-1.5 1.6-.4 3.1-.6 4.5-.6 3.3 0 5.7.9 7.3 2.5zm-4.3 17.3c1.2-1.3 1.8-2.9 1.8-4.8V88h-.9c-2.6 0-4.6.1-6 .4-1.4.2-2.4.6-3 1.2-.6.5-.9 1.3-.9 2.4 0 1.2.4 2.2 1.3 3 .9.8 2 1.1 3.3 1.1 1.7-.1 3.2-.7 4.4-1.9zM165.6 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM189.7 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM232.4 76c1.7 1.1 2.9 2.6 3.9 4.5.9 1.9 1.4 4.2 1.4 6.7s-.5 4.7-1.4 6.6c-.9 1.9-2.2 3.4-3.8 4.4-1.7 1-3.5 1.5-5.7 1.5-1.8 0-3.4-.4-4.8-1.2-1.4-.8-2.5-1.9-3.2-3.4v11.2c0 .7-.2 1.3-.7 1.7-.5.4-1 .6-1.8.6s-1.4-.2-1.9-.7-.7-1-.7-1.8V77c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.7-1.5 1.8-2.6 3.2-3.4s3-1.2 4.8-1.2c2.1 0 4 .6 5.7 1.6zm-1.8 17.6c1.2-1.5 1.8-3.6 1.8-6.3 0-2.8-.6-4.9-1.8-6.5-1.2-1.5-2.9-2.3-5.1-2.3-2.2 0-3.9.8-5.1 2.3-1.2 1.5-1.8 3.6-1.8 6.4s.6 4.9 1.8 6.4c1.2 1.5 2.9 2.3 5.1 2.3 2.2-.1 3.9-.9 5.1-2.3zM247.5 98.2c-1.8-1-3.2-2.5-4.2-4.4-1-1.9-1.5-4.1-1.5-6.7 0-2.6.5-4.8 1.5-6.7 1-1.9 2.4-3.4 4.2-4.4 1.8-1 3.9-1.5 6.3-1.5s4.5.5 6.3 1.5c1.8 1 3.2 2.5 4.2 4.4 1 1.9 1.5 4.2 1.5 6.7s-.5 4.8-1.5 6.7c-1 1.9-2.4 3.4-4.2 4.4-1.8 1-3.9 1.5-6.3 1.5-2.4.1-4.5-.4-6.3-1.5zm11.4-4.6c1.2-1.5 1.8-3.6 1.8-6.5 0-2.8-.6-4.9-1.8-6.4s-2.9-2.2-5.1-2.2c-2.2 0-3.9.7-5.1 2.2s-1.8 3.6-1.8 6.4c0 2.8.6 5 1.8 6.5s2.9 2.2 5.1 2.2 3.9-.7 5.1-2.2zM286.6 76.6c0 .7-.2 1.3-.5 1.6-.4.4-1 .6-1.9.7l-1.5.1c-2.1.2-3.7.9-4.7 2.2-1 1.3-1.5 2.8-1.5 4.6v11.4c0 .8-.2 1.4-.7 1.8-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.5-.4-.7-1-.7-1.8V76.9c0-.8.2-1.4.7-1.8.5-.4 1.1-.6 1.8-.6s1.2.2 1.7.6c.5.4.7 1 .7 1.7v2.4c.7-1.5 1.6-2.6 2.9-3.3 1.3-.8 2.7-1.2 4.3-1.3l.7-.1c1.5-.1 2.3.6 2.3 2.1zM305.3 96.4c.3.3.5.8.5 1.3 0 .7-.3 1.2-.8 1.5-.5.3-1.3.5-2.3.4l-1.4-.1c-2.7-.2-4.7-1-6-2.5s-2-3.6-2-6.4V78.9h-3c-1.5 0-2.2-.7-2.2-2 0-.6.2-1.1.6-1.4.4-.3.9-.5 1.6-.5h3v-5.1c0-.8.2-1.4.7-1.8.5-.4 1.1-.7 1.8-.7s1.4.2 1.9.7c.5.4.7 1 .7 1.8V75h5c.7 0 1.2.2 1.6.5.4.3.6.8.6 1.4 0 .6-.2 1.1-.6 1.5-.4.3-.9.5-1.6.5h-5V91c0 1.6.3 2.7 1 3.5.6.7 1.6 1.2 3 1.3l1.4.1c.7 0 1.2.2 1.5.5z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M152.1 0c-13.5.4-24.4 11.4-24.4 25 0 13.8 11.2 25 25 25s25-11.2 25-25c0-13.5-10.8-24.6-24.2-25h-1.4zm21.8 23.1h-7.2c-.5-6.3-3.3-12.6-8.5-18.6 8.4 2.2 14.9 9.6 15.7 18.6zm-23.2 0h-8c.5-5.6 3.1-11.2 8-16.6v16.6zm0 3.8v16.5c-3-3.3-7.3-9.1-8-16.5h8zm4.2 0h8c-.7 7.3-5 13.1-8 16.4V26.9zm0-3.8V6.5c4.8 5.4 7.5 11 8 16.6h-8zm-7.4-18.7c-5.2 6-8.1 12.3-8.6 18.7h-7.3c.8-9.1 7.3-16.5 15.9-18.7zm-15.9 22.5h7.3c.6 8.4 5.2 14.9 8.7 18.7-8.6-2.2-15.2-9.6-16-18.7zM158 45.6c3.4-3.8 8-10.4 8.6-18.7h7.2c-.7 9-7.2 16.5-15.8 18.7z",
      "fill": "#5fd0b8"
    }
  })])]), _vm._v(" "), _c('span', {
    class: [_vm.checkAuthStatus() ? 'a-loader--white' : ''],
    staticStyle: {
      "margin-top": "90px"
    },
    attrs: {
      "disabled": _vm.running
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Loading...")])])]) : _vm._e(), _vm._v(" "), (_vm.getUserId === null && !_vm.checkAuthStatus()) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('svg', {
    staticClass: "p-passport__icon--passport u-margin-top--small u-margin-bottom--small",
    attrs: {
      "height": "70",
      "width": "200",
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 305.8 108.7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.2 97.4c0 .6-.3 1.2-.8 1.6-.5.4-1.1.7-1.7.7-.4 0-.8-.1-1.2-.4s-.7-.6-.9-1.1l-3.3-7.5H8l-3.3 7.5c-.2.5-.5.8-.9 1.1-.4.3-.8.4-1.3.4-.7 0-1.3-.2-1.8-.7-.5-.4-.8-1-.8-1.6 0-.3.1-.6.3-1l14.1-30.8c.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.6-.5s1.1.1 1.6.5c.5.3.9.7 1.1 1.3L34 96.4c.1.4.2.8.2 1zM9.8 86.6h14.7l-7.3-16.5-7.4 16.5zM65 84.3c1.1 1.5 1.7 3.3 1.7 5.5 0 3-1 5.4-3.1 7.1-2.1 1.7-5 2.5-8.7 2.5H42.1c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12.2c3.6 0 6.5.8 8.5 2.4 2 1.6 3.1 3.9 3.1 6.8 0 1.9-.5 3.5-1.5 4.8-1 1.4-2.4 2.4-4.1 3 2 .7 3.6 1.7 4.7 3.1zm-20.4-4.9h8.9c4.9 0 7.4-1.9 7.4-5.6 0-1.9-.6-3.3-1.8-4.2s-3.1-1.3-5.6-1.3h-8.9v11.1zm15.3 14.5c1.2-.9 1.8-2.4 1.8-4.4 0-2-.6-3.5-1.8-4.5-1.2-1-3.1-1.5-5.6-1.5h-9.7v11.7h9.7c2.6.1 4.4-.4 5.6-1.3zM80 97.7c-2.5-1.4-4.4-3.5-5.8-6.3-1.3-2.7-2-5.9-2-9.6 0-3.7.7-6.9 2-9.6 1.3-2.7 3.3-4.8 5.8-6.3s5.4-2.2 8.8-2.2c2.2 0 4.3.3 6.3 1s3.7 1.7 5.1 3c.6.5 1 1.2 1 2 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.2.6-.6 0-1.1-.2-1.6-.7-1.6-1.2-3.1-2-4.4-2.5-1.3-.5-2.8-.7-4.5-.7-3.7 0-6.5 1.2-8.4 3.6-2 2.4-3 5.8-3 10.2 0 4.5 1 7.9 3 10.3 2 2.4 4.8 3.6 8.4 3.6 1.6 0 3.1-.3 4.4-.8s2.8-1.3 4.5-2.5c.7-.4 1.2-.7 1.6-.7.5 0 .9.2 1.2.6.3.4.5.9.5 1.5 0 .8-.3 1.5-1 2-1.5 1.3-3.2 2.3-5.1 3-2 .7-4 1-6.3 1-3.4.1-6.3-.6-8.8-2zM108 99c-.5-.5-.7-1.1-.7-1.9V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12c3.7 0 6.6.9 8.7 2.8 2.1 1.8 3.1 4.4 3.1 7.8 0 3.3-1 5.9-3.1 7.8-2.1 1.9-5 2.8-8.7 2.8h-9.5v11.8c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7-.1-1.3-.3-1.8-.8zm13.3-17.8c4.9 0 7.4-2.2 7.4-6.5s-2.5-6.4-7.4-6.4h-8.9v12.8h8.9zM156.2 76.9c1.6 1.6 2.4 4.1 2.4 7.5v12.9c0 .8-.2 1.4-.6 1.8-.4.4-1 .6-1.8.6-.7 0-1.3-.2-1.8-.7-.4-.4-.7-1-.7-1.8v-1.8c-.6 1.4-1.6 2.5-2.8 3.2s-2.7 1.1-4.4 1.1c-1.6 0-3.1-.3-4.4-1-1.3-.7-2.4-1.6-3.1-2.7s-1.1-2.5-1.1-3.9c0-1.8.5-3.2 1.4-4.2.9-1 2.4-1.7 4.5-2.2 2.1-.4 5-.7 8.7-.7h1.2v-1.5c0-1.9-.4-3.2-1.2-4-.8-.8-2-1.3-3.7-1.3-1.2 0-2.3.2-3.3.5s-2.2.7-3.4 1.3c-.9.5-1.5.8-1.9.8-.5 0-.9-.2-1.2-.5-.3-.4-.5-.8-.5-1.4 0-.5.1-.9.4-1.3.3-.4.7-.8 1.4-1.1 1.2-.6 2.5-1.1 4.1-1.5 1.6-.4 3.1-.6 4.5-.6 3.3 0 5.7.9 7.3 2.5zm-4.3 17.3c1.2-1.3 1.8-2.9 1.8-4.8V88h-.9c-2.6 0-4.6.1-6 .4-1.4.2-2.4.6-3 1.2-.6.5-.9 1.3-.9 2.4 0 1.2.4 2.2 1.3 3 .9.8 2 1.1 3.3 1.1 1.7-.1 3.2-.7 4.4-1.9zM165.6 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM189.7 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM232.4 76c1.7 1.1 2.9 2.6 3.9 4.5.9 1.9 1.4 4.2 1.4 6.7s-.5 4.7-1.4 6.6c-.9 1.9-2.2 3.4-3.8 4.4-1.7 1-3.5 1.5-5.7 1.5-1.8 0-3.4-.4-4.8-1.2-1.4-.8-2.5-1.9-3.2-3.4v11.2c0 .7-.2 1.3-.7 1.7-.5.4-1 .6-1.8.6s-1.4-.2-1.9-.7-.7-1-.7-1.8V77c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.7-1.5 1.8-2.6 3.2-3.4s3-1.2 4.8-1.2c2.1 0 4 .6 5.7 1.6zm-1.8 17.6c1.2-1.5 1.8-3.6 1.8-6.3 0-2.8-.6-4.9-1.8-6.5-1.2-1.5-2.9-2.3-5.1-2.3-2.2 0-3.9.8-5.1 2.3-1.2 1.5-1.8 3.6-1.8 6.4s.6 4.9 1.8 6.4c1.2 1.5 2.9 2.3 5.1 2.3 2.2-.1 3.9-.9 5.1-2.3zM247.5 98.2c-1.8-1-3.2-2.5-4.2-4.4-1-1.9-1.5-4.1-1.5-6.7 0-2.6.5-4.8 1.5-6.7 1-1.9 2.4-3.4 4.2-4.4 1.8-1 3.9-1.5 6.3-1.5s4.5.5 6.3 1.5c1.8 1 3.2 2.5 4.2 4.4 1 1.9 1.5 4.2 1.5 6.7s-.5 4.8-1.5 6.7c-1 1.9-2.4 3.4-4.2 4.4-1.8 1-3.9 1.5-6.3 1.5-2.4.1-4.5-.4-6.3-1.5zm11.4-4.6c1.2-1.5 1.8-3.6 1.8-6.5 0-2.8-.6-4.9-1.8-6.4s-2.9-2.2-5.1-2.2c-2.2 0-3.9.7-5.1 2.2s-1.8 3.6-1.8 6.4c0 2.8.6 5 1.8 6.5s2.9 2.2 5.1 2.2 3.9-.7 5.1-2.2zM286.6 76.6c0 .7-.2 1.3-.5 1.6-.4.4-1 .6-1.9.7l-1.5.1c-2.1.2-3.7.9-4.7 2.2-1 1.3-1.5 2.8-1.5 4.6v11.4c0 .8-.2 1.4-.7 1.8-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.5-.4-.7-1-.7-1.8V76.9c0-.8.2-1.4.7-1.8.5-.4 1.1-.6 1.8-.6s1.2.2 1.7.6c.5.4.7 1 .7 1.7v2.4c.7-1.5 1.6-2.6 2.9-3.3 1.3-.8 2.7-1.2 4.3-1.3l.7-.1c1.5-.1 2.3.6 2.3 2.1zM305.3 96.4c.3.3.5.8.5 1.3 0 .7-.3 1.2-.8 1.5-.5.3-1.3.5-2.3.4l-1.4-.1c-2.7-.2-4.7-1-6-2.5s-2-3.6-2-6.4V78.9h-3c-1.5 0-2.2-.7-2.2-2 0-.6.2-1.1.6-1.4.4-.3.9-.5 1.6-.5h3v-5.1c0-.8.2-1.4.7-1.8.5-.4 1.1-.7 1.8-.7s1.4.2 1.9.7c.5.4.7 1 .7 1.8V75h5c.7 0 1.2.2 1.6.5.4.3.6.8.6 1.4 0 .6-.2 1.1-.6 1.5-.4.3-.9.5-1.6.5h-5V91c0 1.6.3 2.7 1 3.5.6.7 1.6 1.2 3 1.3l1.4.1c.7 0 1.2.2 1.5.5z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M152.1 0c-13.5.4-24.4 11.4-24.4 25 0 13.8 11.2 25 25 25s25-11.2 25-25c0-13.5-10.8-24.6-24.2-25h-1.4zm21.8 23.1h-7.2c-.5-6.3-3.3-12.6-8.5-18.6 8.4 2.2 14.9 9.6 15.7 18.6zm-23.2 0h-8c.5-5.6 3.1-11.2 8-16.6v16.6zm0 3.8v16.5c-3-3.3-7.3-9.1-8-16.5h8zm4.2 0h8c-.7 7.3-5 13.1-8 16.4V26.9zm0-3.8V6.5c4.8 5.4 7.5 11 8 16.6h-8zm-7.4-18.7c-5.2 6-8.1 12.3-8.6 18.7h-7.3c.8-9.1 7.3-16.5 15.9-18.7zm-15.9 22.5h7.3c.6 8.4 5.2 14.9 8.7 18.7-8.6-2.2-15.2-9.6-16-18.7zM158 45.6c3.4-3.8 8-10.4 8.6-18.7h7.2c-.7 9-7.2 16.5-15.8 18.7z",
      "fill": "#5fd0b8"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "email",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "p-passport__login-error"
  }, [_c('span', [_vm._v("Your credentials are incorrect, please try again.")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button",
    class: [_vm.loggingIn() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": _vm.login
    }
  }, [_c('span', {
    class: [_vm.loggingIn() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Login")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "p-passport__content-new-account",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Don't have an account? "), _c('br'), _vm._v("Create one "), _c('a', {
    attrs: {
      "href": _vm.passportUrl
    }
  }, [_vm._v("here")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.passportUrl + '/password/reset',
      "target": "_blank"
    }
  }, [_vm._v("forgot password?")])]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getUserId !== null && !_vm.checkAuthStatus() && !_vm.isLocked) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('svg', {
    staticClass: "p-passport__icon--passport u-margin-top--small u-margin-bottom--small",
    attrs: {
      "height": "70",
      "width": "200",
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 305.8 108.7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.2 97.4c0 .6-.3 1.2-.8 1.6-.5.4-1.1.7-1.7.7-.4 0-.8-.1-1.2-.4s-.7-.6-.9-1.1l-3.3-7.5H8l-3.3 7.5c-.2.5-.5.8-.9 1.1-.4.3-.8.4-1.3.4-.7 0-1.3-.2-1.8-.7-.5-.4-.8-1-.8-1.6 0-.3.1-.6.3-1l14.1-30.8c.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.6-.5s1.1.1 1.6.5c.5.3.9.7 1.1 1.3L34 96.4c.1.4.2.8.2 1zM9.8 86.6h14.7l-7.3-16.5-7.4 16.5zM65 84.3c1.1 1.5 1.7 3.3 1.7 5.5 0 3-1 5.4-3.1 7.1-2.1 1.7-5 2.5-8.7 2.5H42.1c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12.2c3.6 0 6.5.8 8.5 2.4 2 1.6 3.1 3.9 3.1 6.8 0 1.9-.5 3.5-1.5 4.8-1 1.4-2.4 2.4-4.1 3 2 .7 3.6 1.7 4.7 3.1zm-20.4-4.9h8.9c4.9 0 7.4-1.9 7.4-5.6 0-1.9-.6-3.3-1.8-4.2s-3.1-1.3-5.6-1.3h-8.9v11.1zm15.3 14.5c1.2-.9 1.8-2.4 1.8-4.4 0-2-.6-3.5-1.8-4.5-1.2-1-3.1-1.5-5.6-1.5h-9.7v11.7h9.7c2.6.1 4.4-.4 5.6-1.3zM80 97.7c-2.5-1.4-4.4-3.5-5.8-6.3-1.3-2.7-2-5.9-2-9.6 0-3.7.7-6.9 2-9.6 1.3-2.7 3.3-4.8 5.8-6.3s5.4-2.2 8.8-2.2c2.2 0 4.3.3 6.3 1s3.7 1.7 5.1 3c.6.5 1 1.2 1 2 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.2.6-.6 0-1.1-.2-1.6-.7-1.6-1.2-3.1-2-4.4-2.5-1.3-.5-2.8-.7-4.5-.7-3.7 0-6.5 1.2-8.4 3.6-2 2.4-3 5.8-3 10.2 0 4.5 1 7.9 3 10.3 2 2.4 4.8 3.6 8.4 3.6 1.6 0 3.1-.3 4.4-.8s2.8-1.3 4.5-2.5c.7-.4 1.2-.7 1.6-.7.5 0 .9.2 1.2.6.3.4.5.9.5 1.5 0 .8-.3 1.5-1 2-1.5 1.3-3.2 2.3-5.1 3-2 .7-4 1-6.3 1-3.4.1-6.3-.6-8.8-2zM108 99c-.5-.5-.7-1.1-.7-1.9V66.7c0-.8.2-1.4.7-1.8.4-.5 1.1-.7 1.9-.7h12c3.7 0 6.6.9 8.7 2.8 2.1 1.8 3.1 4.4 3.1 7.8 0 3.3-1 5.9-3.1 7.8-2.1 1.9-5 2.8-8.7 2.8h-9.5v11.8c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7-.1-1.3-.3-1.8-.8zm13.3-17.8c4.9 0 7.4-2.2 7.4-6.5s-2.5-6.4-7.4-6.4h-8.9v12.8h8.9zM156.2 76.9c1.6 1.6 2.4 4.1 2.4 7.5v12.9c0 .8-.2 1.4-.6 1.8-.4.4-1 .6-1.8.6-.7 0-1.3-.2-1.8-.7-.4-.4-.7-1-.7-1.8v-1.8c-.6 1.4-1.6 2.5-2.8 3.2s-2.7 1.1-4.4 1.1c-1.6 0-3.1-.3-4.4-1-1.3-.7-2.4-1.6-3.1-2.7s-1.1-2.5-1.1-3.9c0-1.8.5-3.2 1.4-4.2.9-1 2.4-1.7 4.5-2.2 2.1-.4 5-.7 8.7-.7h1.2v-1.5c0-1.9-.4-3.2-1.2-4-.8-.8-2-1.3-3.7-1.3-1.2 0-2.3.2-3.3.5s-2.2.7-3.4 1.3c-.9.5-1.5.8-1.9.8-.5 0-.9-.2-1.2-.5-.3-.4-.5-.8-.5-1.4 0-.5.1-.9.4-1.3.3-.4.7-.8 1.4-1.1 1.2-.6 2.5-1.1 4.1-1.5 1.6-.4 3.1-.6 4.5-.6 3.3 0 5.7.9 7.3 2.5zm-4.3 17.3c1.2-1.3 1.8-2.9 1.8-4.8V88h-.9c-2.6 0-4.6.1-6 .4-1.4.2-2.4.6-3 1.2-.6.5-.9 1.3-.9 2.4 0 1.2.4 2.2 1.3 3 .9.8 2 1.1 3.3 1.1 1.7-.1 3.2-.7 4.4-1.9zM165.6 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM189.7 97.7c-.6-.4-1-.8-1.3-1.2-.3-.4-.4-.8-.4-1.3s.2-1 .5-1.3.7-.6 1.1-.6c.4 0 1.1.3 2.1.8s2 1 2.9 1.3 2.1.5 3.6.5c1.6 0 2.8-.3 3.8-.9.9-.6 1.3-1.4 1.3-2.4 0-.7-.2-1.2-.5-1.6-.3-.4-1-.8-1.8-1.1-.9-.3-2.2-.7-3.9-1-2.9-.6-5-1.5-6.3-2.6-1.3-1.1-1.9-2.6-1.9-4.4 0-1.4.4-2.7 1.3-3.9s2-2 3.5-2.7c1.5-.6 3.1-1 5-1 1.3 0 2.6.2 3.9.5 1.3.3 2.4.9 3.3 1.5 1.1.7 1.7 1.6 1.7 2.5 0 .5-.2 1-.5 1.4-.3.4-.7.5-1.1.5-.3 0-.6-.1-.9-.2-.3-.1-.7-.3-1.2-.6-.9-.5-1.7-1-2.5-1.3-.8-.3-1.8-.5-2.9-.5-1.4 0-2.5.3-3.4.9-.8.6-1.3 1.4-1.3 2.5 0 .9.4 1.7 1.2 2.2.8.5 2.3 1 4.4 1.5 2.2.5 4 1 5.3 1.6 1.3.6 2.2 1.3 2.7 2.2s.8 2 .8 3.4c0 2.2-.9 3.9-2.7 5.2-1.8 1.3-4.2 2-7.3 2-3.6.2-6.3-.5-8.5-1.9zM232.4 76c1.7 1.1 2.9 2.6 3.9 4.5.9 1.9 1.4 4.2 1.4 6.7s-.5 4.7-1.4 6.6c-.9 1.9-2.2 3.4-3.8 4.4-1.7 1-3.5 1.5-5.7 1.5-1.8 0-3.4-.4-4.8-1.2-1.4-.8-2.5-1.9-3.2-3.4v11.2c0 .7-.2 1.3-.7 1.7-.5.4-1 .6-1.8.6s-1.4-.2-1.9-.7-.7-1-.7-1.8V77c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.7-1.5 1.8-2.6 3.2-3.4s3-1.2 4.8-1.2c2.1 0 4 .6 5.7 1.6zm-1.8 17.6c1.2-1.5 1.8-3.6 1.8-6.3 0-2.8-.6-4.9-1.8-6.5-1.2-1.5-2.9-2.3-5.1-2.3-2.2 0-3.9.8-5.1 2.3-1.2 1.5-1.8 3.6-1.8 6.4s.6 4.9 1.8 6.4c1.2 1.5 2.9 2.3 5.1 2.3 2.2-.1 3.9-.9 5.1-2.3zM247.5 98.2c-1.8-1-3.2-2.5-4.2-4.4-1-1.9-1.5-4.1-1.5-6.7 0-2.6.5-4.8 1.5-6.7 1-1.9 2.4-3.4 4.2-4.4 1.8-1 3.9-1.5 6.3-1.5s4.5.5 6.3 1.5c1.8 1 3.2 2.5 4.2 4.4 1 1.9 1.5 4.2 1.5 6.7s-.5 4.8-1.5 6.7c-1 1.9-2.4 3.4-4.2 4.4-1.8 1-3.9 1.5-6.3 1.5-2.4.1-4.5-.4-6.3-1.5zm11.4-4.6c1.2-1.5 1.8-3.6 1.8-6.5 0-2.8-.6-4.9-1.8-6.4s-2.9-2.2-5.1-2.2c-2.2 0-3.9.7-5.1 2.2s-1.8 3.6-1.8 6.4c0 2.8.6 5 1.8 6.5s2.9 2.2 5.1 2.2 3.9-.7 5.1-2.2zM286.6 76.6c0 .7-.2 1.3-.5 1.6-.4.4-1 .6-1.9.7l-1.5.1c-2.1.2-3.7.9-4.7 2.2-1 1.3-1.5 2.8-1.5 4.6v11.4c0 .8-.2 1.4-.7 1.8-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.5-.4-.7-1-.7-1.8V76.9c0-.8.2-1.4.7-1.8.5-.4 1.1-.6 1.8-.6s1.2.2 1.7.6c.5.4.7 1 .7 1.7v2.4c.7-1.5 1.6-2.6 2.9-3.3 1.3-.8 2.7-1.2 4.3-1.3l.7-.1c1.5-.1 2.3.6 2.3 2.1zM305.3 96.4c.3.3.5.8.5 1.3 0 .7-.3 1.2-.8 1.5-.5.3-1.3.5-2.3.4l-1.4-.1c-2.7-.2-4.7-1-6-2.5s-2-3.6-2-6.4V78.9h-3c-1.5 0-2.2-.7-2.2-2 0-.6.2-1.1.6-1.4.4-.3.9-.5 1.6-.5h3v-5.1c0-.8.2-1.4.7-1.8.5-.4 1.1-.7 1.8-.7s1.4.2 1.9.7c.5.4.7 1 .7 1.8V75h5c.7 0 1.2.2 1.6.5.4.3.6.8.6 1.4 0 .6-.2 1.1-.6 1.5-.4.3-.9.5-1.6.5h-5V91c0 1.6.3 2.7 1 3.5.6.7 1.6 1.2 3 1.3l1.4.1c.7 0 1.2.2 1.5.5z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M152.1 0c-13.5.4-24.4 11.4-24.4 25 0 13.8 11.2 25 25 25s25-11.2 25-25c0-13.5-10.8-24.6-24.2-25h-1.4zm21.8 23.1h-7.2c-.5-6.3-3.3-12.6-8.5-18.6 8.4 2.2 14.9 9.6 15.7 18.6zm-23.2 0h-8c.5-5.6 3.1-11.2 8-16.6v16.6zm0 3.8v16.5c-3-3.3-7.3-9.1-8-16.5h8zm4.2 0h8c-.7 7.3-5 13.1-8 16.4V26.9zm0-3.8V6.5c4.8 5.4 7.5 11 8 16.6h-8zm-7.4-18.7c-5.2 6-8.1 12.3-8.6 18.7h-7.3c.8-9.1 7.3-16.5 15.9-18.7zm-15.9 22.5h7.3c.6 8.4 5.2 14.9 8.7 18.7-8.6-2.2-15.2-9.6-16-18.7zM158 45.6c3.4-3.8 8-10.4 8.6-18.7h7.2c-.7 9-7.2 16.5-15.8 18.7z",
      "fill": "#5fd0b8"
    }
  })])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__button--close",
    class: [_vm.loggingOut() ? 'u-d-none' : ''],
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    class: [_vm.loggingOut() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Continue")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__logout-button",
    class: [_vm.loggingOut() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', {
    class: [_vm.loggingOut() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Logout")])])])]) : _vm._e(), _vm._v(" "), (_vm.getUserId !== null && _vm.isLocked) ? _c('div', [_c('div', {
    staticClass: "p-passport__login"
  }, [_c('h2', {
    staticClass: "u-text-align-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.getUserFullName) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "u-text-align-center u-margin-bottom-30"
  }, [_vm._v("\n                    Your session has timed out,\n                    please enter your password to continue\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Password\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasLockedErrors &&
    !_vm.hasLockedErrors.success &&
    _vm.hasLockedErrors.whitelisted) ? _c('span', {
    staticClass: "p-passport__login-error"
  }, [_c('span', [_vm._v("\n                        Your credentials are incorrect, please try again.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.hasLockedErrors &&
    !_vm.hasLockedErrors.success &&
    !_vm.hasLockedErrors.whitelisted) ? _c('span', {
    staticClass: "p-passport__login-error"
  }, [_c('span', [_vm._v("\n                        Your login attempt has been refused as you have attempted access from outside\n                        of your organisation's whitelisted network range.\n                    ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__button--close u-margin-bottom-0",
    class: [_vm.loggingIn() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": _vm.continueUser
    }
  }, [_c('span', {
    class: [_vm.loggingIn() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Continue")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button p-passport__logout-button",
    class: [_vm.loggingOut() ? 'a-loader--white' : ''],
    attrs: {
      "disabled": _vm.running
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', {
    class: [_vm.loggingOut() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Logout")])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Welcome back to "), _c('br'), _vm._v("ABC Quantum. ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40976754!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Passport.vue
// module id = 1656
// module chunks = 0